import filePropsSetter from '../factories/filePropsSetter'
import setSelectedFiles from '../actions/setSelectedFiles'
import { set, when, merge } from 'cerebral/operators'
import { props, state, string } from 'cerebral/tags'
import inDeleteMediaView from '../actions/inDeleteMediaView'
import createSnackbar from 'modules/App/factories/createSnackbar'
import setTagsForm from './setTagsForm'
import loadDetails from '../actions/loadDetails'

export default [
  inDeleteMediaView,
  {
    true: [
      when(state`media.fetchId`),
      {
        true: [createSnackbar({ key: 'bms.media.fetch.selectAll' }, 'warning')],
        false: [
          filePropsSetter('media.files', { prop: 'selected', value: true }),
          setSelectedFiles,
          when(state`media.selectedFiles`, files => files.length > 0),
          {
            true: [
              set(props`id`, state`media.selectedFiles.0`),
              set(state`media.currentFile`, string`media.files.${props`id`}`),
              when(state`${state`media.currentFile`}.groups`), // if we have groups the media detail is loaded
              {
                true: [],
                false: [
                  set(state`media.tags.isLoading`, true),
                  loadDetails,
                  {
                    loaded: [
                      merge(state`${state`media.currentFile`}`, props`payload`),
                      set(state`media.tags.isLoading`, false)
                    ],
                    error: []
                  }
                ]
              },
              ...setTagsForm
            ],
            false: []
          }
        ]
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/selectAllFilesInState.js